import React from "react"

import styled from "styled-components"

import linkWorm from "./styles/linkWorm"

import UnstyledLink from "./animatedLink"
import SocialMedia from "./socialMedia"
// import LanguageSwitcher from "./languageSwitcher"

export default () => {
  return (
    <Footer>
      <FooterNav>
        <Column>
          <List>
            <ListItem>
              <FooterNavHeader>事業内容</FooterNavHeader>
            </ListItem>
            <ListItem>
              <LinkSub to="/business/event">イベントプロデュース</LinkSub>
            </ListItem>
            <ListItem>
              <LinkSub to="/business/inbound">インバウンド</LinkSub>
            </ListItem>
            <ListItem>
              <LinkSub to="/business/artists">アーティスト</LinkSub>
            </ListItem>
            <ListItem>
              <LinkSub to="/business/advertising">広告</LinkSub>
            </ListItem>
            <ListItem>
              <LinkSub to="/business/club-production">店舗プロデュース</LinkSub>
            </ListItem>
            <ListItem>
              <LinkSub to="/business/other">その他</LinkSub>
            </ListItem>
          </List>
        </Column>
        <Column>
          <List>
            <ListItem>
              <FooterNavHeader>会社概要</FooterNavHeader>
            </ListItem>
            <ListItem>
              <LinkSub to="/company/overview">会社概要</LinkSub>
            </ListItem>
            <ListItem>
              <LinkSub to="/company/officers">グループ役員一覧</LinkSub>
            </ListItem>
            <ListItem>
              <LinkSub to="/company/csr">CSR</LinkSub>
            </ListItem>
            <ListItem>
              <LinkSub to="/company/sdg">SDGs</LinkSub>
            </ListItem>
            <ListItem>
              <LinkSub to="/company/history">沿革</LinkSub>
            </ListItem>
            <ListItem>
              <LinkSub to="/company/works">過去実績</LinkSub>
            </ListItem>
          </List>
        </Column>
        <Column>
          <List>
            <ListItem>
              <FooterNavHeader>グループ会社一覧</FooterNavHeader>
            </ListItem>
            <ListItem>
              <LinkSub to="/group">JAPAN</LinkSub>
            </ListItem>
            <ListItem>
              <LinkSub to="/group">CREATIVE</LinkSub>
            </ListItem>
            <ListItem>
              <LinkSub to="/group">DINING</LinkSub>
            </ListItem>
            <ListItem>
              <LinkSub to="/group">MANAGEMENT</LinkSub>
            </ListItem>
            <ListItem>
              <LinkSub to="/group">TECH</LinkSub>
            </ListItem>
          </List>
        </Column>
        <Column>
          <List>
            <ListItem>
              <LinkMain to="/news">ニュース一覧</LinkMain>
            </ListItem>
            <ListItem>
              <LinkMain to="/recruit">採用情報</LinkMain>
            </ListItem>
            <ListItem>
              <LinkMain to="/contact">お問い合わせ</LinkMain>
            </ListItem>
            <ListItem>
              <LinkMain to="/privacy-policy">プライバシーポリシー</LinkMain>
            </ListItem>
          </List>
        </Column>
      </FooterNav>
      <SocialMediaContainer>
        <SocialMedia />
      </SocialMediaContainer>
      {/* <LanguageSwitcher /> */}
      <Copyright>
        Copyright &copy; 2019 TryHard Japan. All rights reserved.
      </Copyright>
    </Footer>
  )
}

const Footer = styled.footer`
  width: 100%;
  padding: 2rem 0 0 0;
  background: ${({ theme }) => theme.colors.accent};
  color: ${({ theme }) => theme.colors.main};
`

const FooterNav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
  max-width: ${({ theme }) => theme.maxWidth}px;
  margin: 0 auto 2rem;
`

const Column = styled.div`
  width: 100%;

  &:not(:first-child) {
    margin: 2rem 0 0 0;
  }

  @media (min-width: 23.4375em) {
    width: calc(50% - 0.5rem);

    &:not(:first-child) {
      margin: 0;
    }

    &:nth-child(n + 3) {
      margin: 2rem 0 0 0;
    }
  }

  @media (min-width: 48em) {
    width: calc((100% - 3rem) / 4);

    &:nth-child(n + 3) {
      margin: 0;
    }
  }
`

const List = styled.ul`
  margin: 0;
  list-style: none;
`

const ListItem = styled.li``

const FooterNavHeader = styled.span`
  display: inline-block;
  font-size: 1.25rem;
  margin: 0 0 2rem;
`

const Link = styled(UnstyledLink)`
  display: inline-block;
  color: ${({ theme }) => theme.colors.main};
  text-decoration: none;

  ${linkWorm({ color: "main" })}
`

const LinkMain = styled(Link)`
  font-size: 1.25rem;
  margin: 0 0 2rem;
`

const LinkSub = styled(Link)``

const SocialMediaContainer = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.maxWidth}px;
  margin: 1rem auto;
  padding: 1rem 0;
  border: 1px solid ${({ theme }) => theme.colors.main};
  border-left-width: 0;
  border-right-width: 0;
`

const Copyright = styled.p`
  margin: 0;
  padding: 1rem 0;
  text-align: center;
  font-size: 0.75rem;
  background: ${({ theme }) => theme.colors.contrast};
  color: ${({ theme }) => theme.colors.main};
`
